import { camelCase, slugify } from '@sola/utils/string.js';

import { keys } from './keys';
import { articlesUrlBase } from './routes';
import { programCountryLabels } from './sac-values';
import {
  ArticleTermsEnum,
  ArticleTypesEnum,
  articleCategoryOptionsMap,
} from './taxonomy-values';

export const getArticlePath = (
  slug?: string | null,
  articleType?: ArticleTypesEnum | null,
): string => {
  if (!slug) {
    return '';
  }
  // This path does NOT have a trailing slash, so it matches the "path" property of a page.
  return `${articlesUrlBase[articleType || keys.articleTypes.blogPost]}/${slug}`;
};

// @TODO - these 4 functions should move or rewrite

export const getCountryCodeByTerm = (termStr: string): string | undefined => {
  return Object.keys(programCountryLabels).find(
    (key) =>
      slugify(
        programCountryLabels[key as keyof typeof programCountryLabels],
      ) === slugify(termStr),
  );
};

export const getTermCategory = (
  term: ArticleTermsEnum | undefined,
): keyof typeof articleCategoryOptionsMap | undefined => {
  const categories = Object.keys(articleCategoryOptionsMap) as Array<
    keyof typeof articleCategoryOptionsMap
  >;

  if (!term) {
    return undefined;
  }

  return categories.find((category) =>
    (
      articleCategoryOptionsMap[category] as ReadonlyArray<ArticleTermsEnum>
    ).includes(camelCase(term)),
  );
};

export const getCategoryTaxonomy = (category: string) => {
  let taxonomy = '';
  if (category === 'theme') {
    taxonomy = 'articleThemes';
  }
  if (category === 'topic') {
    taxonomy = 'articleTopics';
  }
  if (category === 'types') {
    taxonomy = 'articleTypes';
  }
  return taxonomy;
};

export const parseCountryToArticleTerm = (
  country: string,
): ArticleTermsEnum | string => {
  const label =
    programCountryLabels[country as keyof typeof programCountryLabels];
  if (!label) {
    return slugify(country);
  }
  return slugify(label) as ArticleTermsEnum;
};
